import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "LongarrowDown"
});
const _hoisted_1 = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.7543 7.10681L6.24723 11.1556C6.10705 11.2815 5.89328 11.2815 5.7531 11.1556L1.24571 7.10686C1.09526 6.97171 1.0839 6.74134 1.22035 6.59232L1.24578 6.56713V6.56713L1.86876 6.00781C2.00892 5.88197 2.2226 5.88197 2.36276 6.00781L5.08194 8.44917L5.08068 1.11427C5.0806 0.935442 5.21067 0.786691 5.38223 0.755819L5.4484 0.75V0.75H6.55172C6.75482 0.750027 6.91948 0.913099 6.91952 1.11427L6.92007 8.44917L9.63758 6.00795C9.77776 5.88203 9.99153 5.88202 10.1317 6.00794L10.7543 6.56716C10.9047 6.7023 10.9161 6.93267 10.7797 7.0817L10.7543 7.10681V7.10681Z",
  fill: "#5587FF"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var longarrowDown = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { longarrowDown as default };
